module.exports = __webpack_public_path__ + "img/sunglasses.8f57fdcc.png";